<template>
  <transition name="component-fade" mode="out-in">
    <div v-if="show" class="list-container" @click="closeList"></div>
  </transition>
  <transition name="list-fade" mode="in-out">
    <div v-if="show" class="card bg-white shadow-sm pt-5 c-xf">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          pb-3
        "
        style="padding-right: 1.5rem"
      >
        <div>
          <h5 class="d-flex align-items-start flex-column m-0 p-6">
            {{ translate("question_comp_tepmlate_list_title") }}
            <span class="text-muted mt-1 fs-8"
              >{{ data.length }} {{ translate("Records_Found") }}</span
            >
          </h5>
        </div>
        <div
          class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
          @click="closeList"
          aria-label="Close"
        >
          <i class="bi bi-x-lg"></i>
        </div>
      </div>

      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          pt-4
          pe-4
          pb-4
          border-bottom
          position-relative
        "
        style="padding-left: 2.4rem !important"
      >
        <div class="form-check form-check-custom form-check-solid">
          <button
            class="btn btn-sm btn-white text-danger"
            @click="deleteAll($event)"
          >
            {{ translate("delete_all") }}
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-end"></div>
      </div>

      <ul id="all-location" class="locations-list mt-2 pt-7 ps-3">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="
            d-flex
            align-items-center
            mb-1
            me-2
            border
            rounded
            pt-2
            pb-2
            ps-2
          "
        >
          <!--begin::Bullet-->
          <span class="bullet bullet-vertical h-40px bg-primary"></span>
          <!--end::Bullet-->

          <!--begin::Checkbox-->
          <div class="form-check form-check-custom form-check-solid mx-5">
            <input
              class="form-check-input"
              type="checkbox"
              :id="`template-${item.id}`"
              v-model="item.checked"
              @change="selectTemplate($event, item.id)"
            />
          </div>
          <!--end::Checkbox-->

          <!--begin::Description-->
          <div class="flex-grow-1">
            <div
              v-if="selectedEditItem !== item.id"
              class="d-flex flex-column position-relative w-100"
            >
              <label
                class="
                  form-check-label
                  col-form-label
                  fw-bold
                  p-0
                  user-select-none
                "
                :for="`template-${item.id}`"
                :class="
                  selectedEditItem !== item.id ? '' : 'align-items-center'
                "
              >
                {{ item.name }}
              </label>
            </div>
            <div v-else>
              <div class="input-group border-0 pe-2">
                <input
                  type="text"
                  class="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  :placeholder="item.name"
                  v-model.trim="editValue"
                  @keyup.enter="editTemplate(index)"
                />
                <a
                  class="input-group-text"
                  id="inputGroup-sizing-sm"
                  style="cursor: pointer"
                  @click="editTemplate(index)"
                  ><i class="bi bi-check-lg text-primary"></i
                ></a>
              </div>
            </div>
          </div>
          <!--end::Description-->
          <div
            class="btn btn-icon btn-sm btn-active-light-primary me-2"
            @click="selectEdit(item.id)"
          >
            <i class="bi bi-pencil"></i>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-danger me-2"
            @click="deleteTemplate($event, item.id)"
          >
            <i class="bi bi-trash"></i>
          </div>
        </div>
      </ul>
      <ConfirmPopup group="deleteTemplate"></ConfirmPopup>
    </div>
  </transition>
</template>

<script setup>
import { ref, defineEmits, onMounted } from "vue";
import { useConfirm } from "primevue/useconfirm";
import { useI18n } from "vue-i18n";
import {
  saveTemplate,
  getTemplate,
  destroyTemplate,
  returnChekedTemplate,
} from "@/store/utils/templateService";

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const emit = defineEmits(["closeList"]);
const data = ref([]);
const show = ref(false);

//Confirm Message
const confirm = useConfirm();

//Edit Template
const editValue = ref(null);
const selectedEditItem = ref(null);
const selectEdit = (id) => {
  if (selectedEditItem.value !== id) selectedEditItem.value = id;
  else selectedEditItem.value = null;

  editValue.value = null;
};
const editTemplate = (index) => {
  if (editValue.value !== "" && editValue.value !== null) {
    data.value[index].name = editValue.value;
    saveTemplate(JSON.stringify(data.value));
  }
  selectedEditItem.value = null;
  editValue.value = null;
};

// Select Template
const selectTemplate = ($event, id) => {
  data.value.forEach((template) => {
    if (template.id !== id) template.checked = false;
  });
  saveTemplate(JSON.stringify(data.value));
};

// Delete Template
const deleteAll = (event) => {
  confirm.require({
    group: "deleteTemplate",
    target: event.currentTarget,
    message: translate("question_comp_tepmlate_list_confirm_delete_all_msg"),
    icon: "bi bi-exclamation-lg",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-light-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      data.value = [];
      destroyTemplate();
    },
    reject: () => {
      return;
    },
  });
};

const deleteTemplate = (event, id) => {
  confirm.require({
    group: "deleteTemplate",
    target: event.currentTarget,
    message: translate("question_comp_tepmlate_list_confirm_delete_msg"),
    icon: "bi bi-exclamation-lg",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-light-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      data.value = data.value.filter((item) => item.id !== id);
      saveTemplate(JSON.stringify(data.value));
    },
    reject: () => {
      return;
    },
  });
};

const closeList = () => {
  show.value = false;
  setTimeout(() => {
    emit("closeList");
  }, 500);
};

data.value = getTemplate() === null ? [] : JSON.parse(getTemplate());
onMounted(() => {
  returnChekedTemplate();
  setTimeout(() => {
    show.value = true;
  }, 30);
});
</script>

<style scoped>
.list-fade-enter-active,
.list-fade-leave-active {
  transition: all 0.5s ease;
}
.list-fade-enter-from,
.list-fade-leave-to {
  transform: translateX(500px);
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.5s ease;
}

.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}
.list-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.219);
  z-index: 100;
  overflow-x: hidden;
  overflow-y: auto;
}
.c-xf {
  position: fixed;
  width: 500px;
  height: 100vh;
  top: 0px;
  right: 0;
  z-index: 101;
  border-radius: 5px 0 0 5px;
  overflow-x: hidden;
  overflow-y: auto;
}
@media only screen and (max-width: 600px) {
  .c-xf {
    width: 100%;
    border-radius: 0;
  }
}
.locations-list {
  padding: 0%;
  background: white;
  width: 100%;
  max-height: 100vh;
  overflow: scroll;
  overflow-x: hidden;
}
</style>
